<div class="notification-dialog" (click)="onViewClick()">
  <div mat-dialog-content class="dialog-content">
    <div class="notification-content">
      <div class="notification-icon">
        <mat-icon *ngIf="data.icon">{{ data.icon }}</mat-icon>
        <mat-icon *ngIf="!data.icon">notifications</mat-icon>
      </div>
      <div class="notification-text">
        <div class="notification-title">{{ data.title || 'Notification' }}</div>
        <div class="notification-body">{{ data.body }}</div>
      </div>
      <button mat-icon-button (click)="onClose(); $event.stopPropagation()" class="close-button">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</div>